import { SignalDoc, SignalType } from "@megaron/docs-contracts";

import { SignalDocumentGroup, groupSignals } from "./groupSignals";
import { isSignalUnread } from "./signalUnread";

export type NavBadgeState = {
  count: number;
  hasUnread: boolean;
};

const badgeGroupSignals = (group: SignalDocumentGroup, badgeSignalTypes: ReadonlySet<string>): SignalDoc[] =>
  group.signals.filter((signal) => badgeSignalTypes.has(signal.signalType));

export const navBadgeState = (signals: SignalDoc[], badgeSignalTypes: readonly SignalType[]): NavBadgeState => {
  if (badgeSignalTypes.length === 0) return { count: 0, hasUnread: false };

  const allowedTypes = new Set<string>(badgeSignalTypes);

  const badgeGroups = groupSignals(signals)
    .map((group) => badgeGroupSignals(group, allowedTypes))
    .filter((badgeSignals) => badgeSignals.length > 0);

  return {
    count: badgeGroups.length,
    hasUnread: badgeGroups.some((badgeSignals) => badgeSignals.some(isSignalUnread)),
  };
};

export const navBadgeGroupCount = (signals: SignalDoc[], badgeSignalTypes: readonly SignalType[]): number =>
  navBadgeState(signals, badgeSignalTypes).count;
